module.exports = __webpack_public_path__ + "static/media/Attachment 3 - 10 Point Business Plan Guidelines.3cc97304.pdf";